import React, {useEffect, useState,forwardRef, useImperativeHandle} from "react";
import Collapse from '@mui/material/Collapse';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import { useDispatch } from "react-redux";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";
import { Config } from "../../../Utils/Config";

export const MyMarketLayout = forwardRef((props, ref) => {
  const [marketNames, setMarketNames] = useState([]);
  const dispatch = useDispatch();
  const {id} = useParams();
  const navigate = useNavigate();
  useImperativeHandle(ref, () => ({
    updateMarketNames(){
      fetchMyMarketNames();
    }
  }));
  const fetchMyMarketNames = () => {
     let inputData={ "page":1,
        "resultsPerPage":20,
        "orderBy":"CreatedDate",
        "orderDirection":"ASC",
        "ShowMarketNameOnly": true}
       apiCommonTrigger("post",`${Config.API_URL}/markets`,inputData)
      .then((res) => {
        if (res.status === 200) {
          setMarketNames(res.data.markets);
        }
        else{
          handlingCatchError(res, navigate);
        }
      })
      .catch((err) => {
        handlingCatchError(err, navigate);
      });
    }


  useEffect(() => {
    fetchMyMarketNames();
  },[])

  const redirectMarketPage = (id) => {
    dispatch({ type: 'developmentFilters', value: [] });
    const filterResetBtn = document.getElementById("reset-btn-filter");
    if (filterResetBtn) filterResetBtn.click();
    navigate("/market-dashboard/interactive-map/"+id);
  }

  var currentDate = moment(new Date()).utc().format('YYYY-MM-DD');

  return (
    <div>
      <Collapse in={props.openMyMarket} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {marketNames && marketNames.length > 0 && marketNames.filter(x => (x.validtill && moment(x.validtill).utc().format('YYYY-MM-DD') > currentDate) || x.validtill === null).map(market => (
            <ListItemButton className={Number(id) === market.id?"navigation-link active":"navigation-link"} sx={{ pl: 4 }} key={market.id}>
              <label onClick={()=> redirectMarketPage(market.id)}><ListItemText primary={market.marketname} /></label>
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </div>
  );

});

